import ListPage from "../../components/Page/listPage";
import { Modal } from "antd";
import { useState, useEffect } from "react";
import CircularProgress from "../../components/CircularProgress";
import FactorDetail from "../../components/FactorDetail";
import { getAllRequests } from "../../API/RequestHistory";

const ErrorModal = Modal.error;
const DetailModal = Modal.info;

export default function RequestHistory() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  function findData(){
    setLoading(true);
    getAllRequests()
      .then((i) => {
        if (i.success) {
          setData(i.data);
        } else {
          ErrorModal({
            title: "خطا",
            content: "مشکلی هنگان انجام عمیلات رخداد",
            okText: "باشد",
            okType: "danger",
            onOk() {},
          });
        }
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((i) => {
        ErrorModal({
          title: "خطا",
          content: "مشکلی هنگان انجام عمیلات رخداد" + i,
          okText: "باشد",
          okType: "danger",
          onOk() {},
        });
      });
  }

  useEffect(() => {
    findData();
  }, []);

  const columns = [
    {
      title: "مشتری",
      dataIndex: "customer",
      key: "customer",
      search: true,
    },
    {
      title: "شماره فاکتور",
      dataIndex: "shom_Invoice",
      key: "shom_Invoice",
      search: true,
      width: 250,
    },
    {
      title: "تاریخ",
      dataIndex: "date",
      key: "date",
      search: true,
    },
    {
      title: "توضیحات",
      dataIndex: "comment",
      key: "comment",
      search: true,
    },
    {
      title: "تخفیف",
      dataIndex: "disscount",
      key: "disscount",
      search: true,
    },
    {
      title: "جزئیات",
      dataIndex: "details",
      key: "details",
      render: (text, record) => (
        <span>
          <span
            className="gx-link"
            onClick={() => {
              DetailModal({title:record.shom_Invoice,
                content:<><FactorDetail shomInvoice={record.shom_Invoice}/></>,
                okText:"تایید"
              })
              
            }}
          >
            جزئیات
          </span>
        </span>
      ),
    },
  ];

  const tableTitles = ["مشتری", "شماره فاکتور", "تاریخ", "توضیحات", "تخفیف"];

  return (
    <>
      {loading && <CircularProgress />}
      {!loading && (
        <ListPage
          columns={columns}
          data={data}
          tableTitles={tableTitles}
          pagsize={15}
          reloader={findData}
        />
      )}
    </>
  );
}

